import {
  Card,
  Grid,
  Box,
  Typography,
  Divider,
  Chip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Icon,
  IconButton,
  Alert,
  Tab,
  Tabs,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  MenuItem
} from "@mui/material";
import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  updateScreenTitle,
  showSuccessMessage,
  showLoader,
  dismissLoader
} from "../../../../LayoutContainers/AppLayout/redux/AppSlice";
import WDBox from "../../../../MaterialComponents/WDBox";
import WDButton from "../../../../MaterialComponents/WDButton";
import moment from "moment";
import partnerAPI from "../../../../services/channelPartnerService";
import ChannelPartnerUsers from "./ChannelPartnerUsers";

// DUMMY DATA
const DUMMY_PARTNER_DETAILS = {
  'cp-001': {
    id: 'cp-001',
    name: 'Elite Business Consultants',
    contactPerson: 'Sarah Johnson',
    contactNumber: '+971 50 123 4567',
    email: 'sarah.j@elitebiz.ae',
    address: 'Business Bay, Dubai',
    commissionType: 'PERCENTAGE',
    commissionValue: 20,
    referredCustomersCount: 15,
    totalCommissionEarned: 45000,
    pendingCommission: 5200,
    paidCommission: 39800,
    createdAt: new Date(Date.now() - 180 * 86400000).toISOString(),
    active: true,
    paymentTerms: 'MONTHLY',
    bankAccountName: 'Elite Business Consultants LLC',
    accountNumber: '**** **** 1234',
    bankName: 'Emirates NBD',
  }
};

const DUMMY_REFERRED_CUSTOMERS = [
  {
    id: 'cust-001',
    name: 'Tech Innovations LLC',
    joinDate: new Date(Date.now() - 150 * 86400000).toISOString(),
    totalRevenue: 85000,
    commissionEarned: 8500,
    activeTickets: 3,
    status: 'Active'
  },
  {
    id: 'cust-002',
    name: 'Gulf Trading Co.',
    joinDate: new Date(Date.now() - 120 * 86400000).toISOString(),
    totalRevenue: 62000,
    commissionEarned: 6200,
    activeTickets: 1,
    status: 'Active'
  },
  {
    id: 'cust-003',
    name: 'Digital Solutions DMCC',
    joinDate: new Date(Date.now() - 90 * 86400000).toISOString(),
    totalRevenue: 123000,
    commissionEarned: 12300,
    activeTickets: 5,
    status: 'Active'
  },
  {
    id: 'cust-004',
    name: 'Marketing Pros',
    joinDate: new Date(Date.now() - 60 * 86400000).toISOString(),
    totalRevenue: 45000,
    commissionEarned: 4500,
    activeTickets: 0,
    status: 'Inactive'
  }
];

const DUMMY_PAYMENT_HISTORY = [
  {
    id: 'pay-001',
    date: new Date(Date.now() - 30 * 86400000).toISOString(),
    amount: 12500,
    period: 'September 2025',
    status: 'Paid',
    paymentMethod: 'Bank Transfer',
    referenceNumber: 'TXN-2025-09-001'
  },
  {
    id: 'pay-002',
    date: new Date(Date.now() - 60 * 86400000).toISOString(),
    amount: 14200,
    period: 'August 2025',
    status: 'Paid',
    paymentMethod: 'Bank Transfer',
    referenceNumber: 'TXN-2025-08-001'
  },
  {
    id: 'pay-003',
    date: new Date(Date.now() - 90 * 86400000).toISOString(),
    amount: 13100,
    period: 'July 2025',
    status: 'Paid',
    paymentMethod: 'Bank Transfer',
    referenceNumber: 'TXN-2025-07-001'
  },
  {
    id: 'pay-004',
    date: new Date().toISOString(),
    amount: 5200,
    period: 'October 2025',
    status: 'Pending',
    paymentMethod: 'Bank Transfer',
    referenceNumber: '-'
  }
];

const DUMMY_COMMISSION_BREAKDOWN = [
  {
    serviceName: 'Visa Renewal',
    transactions: 45,
    totalRevenue: 135000,
    commissionEarned: 13500
  },
  {
    serviceName: 'New Visa Application',
    transactions: 28,
    totalRevenue: 112000,
    commissionEarned: 11200
  },
  {
    serviceName: 'Trade License Renewal',
    transactions: 12,
    totalRevenue: 96000,
    commissionEarned: 9600
  },
  {
    serviceName: 'Business Setup',
    transactions: 8,
    totalRevenue: 240000,
    commissionEarned: 10700
  }
];

// This will be populated from API calls
let EXISTING_CUSTOMERS_POOL = [];

const ChannelPartnerDetail = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Get partner data from location state
  const partnerId = location.state?.partnerId;
  const apiPartnerData = location.state?.partnerData;

  // Extract organisation details from API data
  const org = apiPartnerData?.organisation || {};
  const partnerDetails = {
    id: apiPartnerData?.id,
    name: org.name || 'N/A',
    contactPerson: org.contactPerson || 'N/A',
    contactNumber: org.contactNumber || 'N/A',
    email: org.email || 'N/A',
    address: org.address || 'N/A',
    commissionType: 'PERCENTAGE',
    commissionValue: apiPartnerData?.commissionPercentage || 0,
    active: apiPartnerData?.status === 'ACTIVE',
    paymentTerms: 'MONTHLY',
    referredCustomersCount: apiPartnerData?.successfulReferrals || 0,
    totalCommissionEarned: apiPartnerData?.totalCommissionEarned || 0,
    pendingCommission: 0,
    paidCommission: 0,
    createdAt: apiPartnerData?.createDateTime,
    bankAccountName: 'N/A',
    accountNumber: 'N/A',
    bankName: 'N/A'
  };

  const [currentTab, setCurrentTab] = useState(0);
  const [isMockMode, setIsMockMode] = useState(false);
  const [referredCustomers, setReferredCustomers] = useState([]);
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [isEditLoading, setIsEditLoading] = useState(false);
  const [editFormData, setEditFormData] = useState({
    name: org.name || '',
    contactPerson: org.contactPerson || '',
    email: org.email || '',
    contactNumber: org.contactNumber || '',
    address: org.address || ''
  });

  // Dialog state for linking existing customer
  const [linkCustomerDialogOpen, setLinkCustomerDialogOpen] = useState(false);
  const [selectedExistingCustomer, setSelectedExistingCustomer] = useState('');

  useEffect(() => {
    console.log('[ChannelPartnerDetail] Component mounted/updated - linkCustomerDialogOpen:', linkCustomerDialogOpen);
  }, [linkCustomerDialogOpen]);

  // Fetch existing customers on component mount
  useEffect(() => {
    console.log('[ChannelPartnerDetail] useEffect hook triggered - setting up customer fetch');
    const fetchCustomers = async () => {
      try {
        console.log('[ChannelPartnerDetail] ===== Starting to fetch customers from API =====');

        // Fetch organisations by type - we want CUSTOMER and PARTNER types (not CHANNEL_PARTNER or ADMIN)
        const allCustomers = [];

        // Fetch CUSTOMER type organisations
        try {
          console.log('[ChannelPartnerDetail] Fetching CUSTOMER type organisations...');
          const customerResponse = await partnerAPI.get('/api/organisations?type=CUSTOMER');
          const customerList = Array.isArray(customerResponse.data) ? customerResponse.data : (customerResponse.data?.data || []);
          console.log('[ChannelPartnerDetail] Fetched CUSTOMER organizations:', customerList.length);
          allCustomers.push(...customerList);
        } catch (customerError) {
          console.error('[ChannelPartnerDetail] Error fetching CUSTOMER type:', customerError.message);
        }

        // Fetch PARTNER type organisations
        try {
          console.log('[ChannelPartnerDetail] Fetching PARTNER type organisations...');
          const partnerResponse = await partnerAPI.get('/api/organisations?type=PARTNER');
          const partnerList = Array.isArray(partnerResponse.data) ? partnerResponse.data : (partnerResponse.data?.data || []);
          console.log('[ChannelPartnerDetail] Fetched PARTNER organizations:', partnerList.length);
          allCustomers.push(...partnerList);
        } catch (partnerError) {
          console.error('[ChannelPartnerDetail] Error fetching PARTNER type:', partnerError.message);
        }

        console.log('[ChannelPartnerDetail] Total fetched organizations:', allCustomers.length);
        console.log('[ChannelPartnerDetail] All customers:', allCustomers);

        // Map to customer list format
        const customerList = allCustomers.map(org => ({
          id: org.id,
          name: org.name,
          accountNumber: org.organizationCode || 'N/A',
          totalRevenue: 0
        }));

        EXISTING_CUSTOMERS_POOL = customerList;
        console.log('[ChannelPartnerDetail] ===== Final customer list =====');
        console.log('[ChannelPartnerDetail] Final customer list:', customerList);
        console.log('[ChannelPartnerDetail] Customer pool size:', EXISTING_CUSTOMERS_POOL.length);
      } catch (error) {
        console.error('[ChannelPartnerDetail] ===== ERROR fetching customers =====');
        console.error('[ChannelPartnerDetail] Error:', error);
        console.error('[ChannelPartnerDetail] Error message:', error.message);
        EXISTING_CUSTOMERS_POOL = [];
      }
    };

    console.log('[ChannelPartnerDetail] Calling fetchCustomers function...');
    fetchCustomers();
    console.log('[ChannelPartnerDetail] fetchCustomers function call initiated');
  }, []);

  // Fetch referred customers from database when partner details are loaded
  useEffect(() => {
    if (!partnerId) return;

    const fetchReferredCustomers = async () => {
      try {
        console.log('[ChannelPartnerDetail] Fetching referred customers from backend for partner:', partnerId);
        const response = await partnerAPI.get(`/api/channel-partners/${partnerId}/referred-customers`);

        if (Array.isArray(response.data)) {
          console.log('[ChannelPartnerDetail] Fetched referred customers:', response.data);
          // Map the backend response to the format needed for display
          const mappedCustomers = response.data.map(referral => ({
            id: referral.customer.id,
            name: referral.customer.name,
            joinDate: referral.customer.createDateTime || referral.createDateTime,
            totalRevenue: 0, // Will be calculated from commission
            commissionEarned: 0,
            activeTickets: 0,
            status: referral.status || 'Active',
            referralId: referral.id // Store the referral relationship ID
          }));
          setReferredCustomers(mappedCustomers);
          setIsMockMode(false);
        }
      } catch (error) {
        console.warn('[ChannelPartnerDetail] Error fetching referred customers from database:', error.message);
        // Fall back to empty list (no mock data)
        setReferredCustomers([]);
      }
    };

    fetchReferredCustomers();
  }, [partnerId]);

  useEffect(() => {
    dispatch(updateScreenTitle(`${partnerDetails.name} - Details`));
    return () => dispatch(updateScreenTitle(""));
  }, [dispatch, partnerDetails.name]);

  const handleTabChange = (event, newValue) => {
    setCurrentTab(newValue);
  };

  const handleOpenEditDialog = () => {
    setEditFormData({
      name: partnerDetails.name,
      contactPerson: partnerDetails.contactPerson,
      email: partnerDetails.email,
      contactNumber: partnerDetails.contactNumber,
      address: partnerDetails.address
    });
    setEditDialogOpen(true);
  };

  const handleSaveEditChanges = async () => {
    setIsEditLoading(true);
    try {
      dispatch(showLoader());

      // Call API to update the channel partner organization using partnerAPI with proper token handling
      await partnerAPI.put(`/api/organisations/${partnerId}`, editFormData);

      dispatch(showSuccessMessage('Channel partner details updated successfully'));
      setEditDialogOpen(false);
      // Reload the page to show updated details
      window.location.reload();
    } catch (error) {
      console.error('Error updating channel partner:', error);
      const errorMsg = error.response?.data?.message || error.message || 'Failed to update details';
      dispatch(showSuccessMessage(`Error: ${errorMsg}`));
    } finally {
      dispatch(dismissLoader());
      setIsEditLoading(false);
    }
  };

  const handleLinkCustomer = () => {
    console.log('[ChannelPartnerDetail] Link Customer button clicked');
    console.log('[ChannelPartnerDetail] Current EXISTING_CUSTOMERS_POOL size:', EXISTING_CUSTOMERS_POOL.length);
    console.log('[ChannelPartnerDetail] EXISTING_CUSTOMERS_POOL:', EXISTING_CUSTOMERS_POOL);
    setSelectedExistingCustomer('');
    setLinkCustomerDialogOpen(true);
    console.log('[ChannelPartnerDetail] Dialog state set to open');
  };

  const handleSaveLinkedCustomer = async () => {
    dispatch(showLoader());

    try {
      const existingCustomer = EXISTING_CUSTOMERS_POOL.find(c => c.id === selectedExistingCustomer);
      if (!existingCustomer) {
        dispatch(showSuccessMessage('Please select a customer'));
        dispatch(dismissLoader());
        return;
      }

      // Check if already linked
      if (referredCustomers.find(c => c.id === existingCustomer.id)) {
        dispatch(showSuccessMessage('Customer is already linked to this partner'));
        setLinkCustomerDialogOpen(false);
        dispatch(dismissLoader());
        return;
      }

      // Call API to link customer to channel partner
      console.log('[ChannelPartnerDetail] Linking customer to channel partner...');
      console.log('[ChannelPartnerDetail] Channel Partner ID:', partnerId);
      console.log('[ChannelPartnerDetail] Customer ID:', existingCustomer.id);

      try {
        // Try to link customer via API
        const linkResponse = await partnerAPI.post(`/api/channel-partners/${partnerId}/link-customer`, {
          customerId: existingCustomer.id,
          organisationId: existingCustomer.id
        });

        console.log('[ChannelPartnerDetail] Link response:', linkResponse);

        // Refresh the referred customers list from the backend
        try {
          const refreshResponse = await partnerAPI.get(`/api/channel-partners/${partnerId}/referred-customers`);
          if (Array.isArray(refreshResponse.data)) {
            console.log('[ChannelPartnerDetail] Refreshed referred customers:', refreshResponse.data);
            const mappedCustomers = refreshResponse.data.map(referral => ({
              id: referral.customer.id,
              name: referral.customer.name,
              joinDate: referral.customer.createDateTime || referral.createDateTime,
              totalRevenue: 0,
              commissionEarned: 0,
              activeTickets: 0,
              status: referral.status || 'Active',
              referralId: referral.id
            }));
            setReferredCustomers(mappedCustomers);
            setIsMockMode(false);
          }
        } catch (refreshError) {
          console.warn('[ChannelPartnerDetail] Error refreshing referred customers:', refreshError.message);
          // Fallback: just add the customer to the list locally
          const newCustomer = {
            id: existingCustomer.id,
            name: existingCustomer.name,
            joinDate: new Date().toISOString(),
            totalRevenue: 0,
            commissionEarned: 0,
            activeTickets: 0,
            status: 'Active'
          };
          setReferredCustomers([...referredCustomers, newCustomer]);
        }

        dispatch(showSuccessMessage('Customer linked successfully!'));
        setLinkCustomerDialogOpen(false);
      } catch (apiError) {
        console.error('[ChannelPartnerDetail] API error linking customer:', apiError);

        // If API endpoint doesn't exist, still add to UI (mock mode)
        if (apiError.response?.status === 404) {
          console.log('[ChannelPartnerDetail] Endpoint not found - adding to UI only (mock mode)');
          const newCustomer = {
            id: existingCustomer.id,
            name: existingCustomer.name,
            joinDate: new Date().toISOString(),
            totalRevenue: 0,
            commissionEarned: 0,
            activeTickets: 0,
            status: 'Active'
          };

          setReferredCustomers([...referredCustomers, newCustomer]);
          dispatch(showSuccessMessage('Customer added to list (awaiting backend implementation)'));
          setLinkCustomerDialogOpen(false);
        } else {
          throw apiError;
        }
      }
    } catch (error) {
      console.error('[ChannelPartnerDetail] Error linking customer:', error);
      const errorMsg = error.response?.data?.message || error.message || 'Failed to link customer';
      dispatch(showSuccessMessage(`Error: ${errorMsg}`));
    } finally {
      dispatch(dismissLoader());
    }
  };

  const getUnlinkedCustomers = () => {
    const linkedCustomerIds = referredCustomers.map(c => c.id);
    return EXISTING_CUSTOMERS_POOL.filter(ec => !linkedCustomerIds.includes(ec.id));
  };

  console.log('[ChannelPartnerDetail] Rendering component - linkCustomerDialogOpen:', linkCustomerDialogOpen, 'EXISTING_CUSTOMERS_POOL size:', EXISTING_CUSTOMERS_POOL.length);

  return (
    <WDBox py={1}>
      {isMockMode && (
        <Alert severity="warning" icon={<Icon>info</Icon>} sx={{ mb: 2 }}>
          <strong>Mock Mode:</strong> Displaying dummy data. Real API integration pending.
        </Alert>
      )}

      {/* Partner Summary Card */}
      <Card sx={{ p: 3, mb: 2 }}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={8}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
              <Icon sx={{ fontSize: 32, color: 'primary.main' }}>business</Icon>
              <Box>
                <Typography variant="h6" sx={{ fontSize: '1.25rem', fontWeight: 600 }}>
                  {partnerDetails.name}
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.813rem' }}>
                  Partner ID: {partnerDetails.id}
                </Typography>
              </Box>
              <Chip
                label={partnerDetails.active ? 'Active' : 'Inactive'}
                color={partnerDetails.active ? 'success' : 'default'}
                sx={{ ml: 2, height: 24, fontSize: '0.75rem' }}
              />
            </Box>

            <Grid container spacing={2}>
              <Grid item xs={6} md={3}>
                <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.75rem' }}>
                  Contact Person
                </Typography>
                <Typography variant="body2" sx={{ fontSize: '0.875rem' }}>
                  {partnerDetails.contactPerson}
                </Typography>
              </Grid>
              <Grid item xs={6} md={3}>
                <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.75rem' }}>
                  Email
                </Typography>
                <Typography variant="body2" sx={{ fontSize: '0.875rem' }}>
                  {partnerDetails.email}
                </Typography>
              </Grid>
              <Grid item xs={6} md={3}>
                <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.75rem' }}>
                  Phone
                </Typography>
                <Typography variant="body2" sx={{ fontSize: '0.875rem' }}>
                  {partnerDetails.contactNumber}
                </Typography>
              </Grid>
              <Grid item xs={6} md={3}>
                <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.75rem' }}>
                  Address
                </Typography>
                <Typography variant="body2" sx={{ fontSize: '0.875rem' }}>
                  {partnerDetails.address}
                </Typography>
              </Grid>
              <Grid item xs={6} md={3}>
                <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.75rem' }}>
                  Commission Rate
                </Typography>
                <Typography variant="body2" sx={{ fontWeight: 600, fontSize: '0.875rem' }}>
                  {partnerDetails.commissionType === 'PERCENTAGE'
                    ? `${partnerDetails.commissionValue}%`
                    : `AED ${partnerDetails.commissionValue}`}
                </Typography>
              </Grid>
              <Grid item xs={6} md={3}>
                <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.75rem' }}>
                  Payment Terms
                </Typography>
                <Typography variant="body2" sx={{ fontSize: '0.875rem' }}>
                  {partnerDetails.paymentTerms}
                </Typography>
              </Grid>
              <Grid item xs={6} md={3}>
                <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.75rem' }}>
                  Member Since
                </Typography>
                <Typography variant="body2" sx={{ fontSize: '0.875rem' }}>
                  {moment(partnerDetails.createdAt).format('MMM YYYY')}
                </Typography>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} md={4}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, alignItems: 'flex-end' }}>
              <WDButton
                variant="gradient"
                color="info"
                startIcon={<Icon sx={{ fontSize: '18px !important' }}>settings</Icon>}
                onClick={() => navigate('/ADM-ChannelPartners/adm-commission-config', {
                  state: { partnerId }
                })}
                sx={{
                  py: 1.25,
                  px: 3.5,
                  fontSize: '0.875rem',
                  textTransform: 'none',
                  fontWeight: 600,
                  minWidth: 'auto',
                  borderRadius: 2,
                  boxShadow: '0 4px 12px rgba(33, 150, 243, 0.25)',
                  '&:hover': {
                    boxShadow: '0 6px 16px rgba(33, 150, 243, 0.35)',
                    transform: 'translateY(-1px)'
                  },
                  transition: 'all 0.2s ease-in-out'
                }}
              >
                Configure Commission
              </WDButton>
              <WDButton
                variant="outlined"
                color="secondary"
                startIcon={<Icon sx={{ fontSize: '18px !important' }}>edit</Icon>}
                onClick={handleOpenEditDialog}
                sx={{
                  py: 1.25,
                  px: 3.5,
                  fontSize: '0.875rem',
                  textTransform: 'none',
                  fontWeight: 600,
                  minWidth: 'auto',
                  borderRadius: 2,
                  borderWidth: 1.5,
                  '&:hover': {
                    borderWidth: 1.5,
                    transform: 'translateY(-1px)',
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)'
                  },
                  transition: 'all 0.2s ease-in-out'
                }}
              >
                Edit Details
              </WDButton>
              <WDButton
                variant="outlined"
                color="success"
                startIcon={<Icon sx={{ fontSize: '18px !important' }}>payment</Icon>}
                sx={{
                  py: 1.25,
                  px: 3.5,
                  fontSize: '0.875rem',
                  textTransform: 'none',
                  fontWeight: 600,
                  minWidth: 'auto',
                  borderRadius: 2,
                  borderWidth: 1.5,
                  '&:hover': {
                    borderWidth: 1.5,
                    transform: 'translateY(-1px)',
                    boxShadow: '0 4px 12px rgba(46, 125, 50, 0.2)'
                  },
                  transition: 'all 0.2s ease-in-out'
                }}
              >
                Process Payment
              </WDButton>
            </Box>
          </Grid>
        </Grid>
      </Card>

      {/* Statistics Cards */}
      <Grid container spacing={2} sx={{ mb: 2 }}>
        <Grid item xs={12} sm={6} md={3}>
          <Card sx={{ p: 2, borderRadius: 2 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, mb: 0.75 }}>
              <Icon color="primary" sx={{ fontSize: '1.25rem' }}>people</Icon>
              <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.75rem' }}>
                Referred Customers
              </Typography>
            </Box>
            <Typography variant="h5" sx={{ fontSize: '1.75rem', fontWeight: 600 }}>
              {partnerDetails.referredCustomersCount}
            </Typography>
          </Card>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <Card sx={{ p: 2, borderRadius: 2 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, mb: 0.75 }}>
              <Icon sx={{ color: 'success.main', fontSize: '1.25rem' }}>account_balance_wallet</Icon>
              <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.75rem' }}>
                Total Earned
              </Typography>
            </Box>
            <Typography variant="h5" sx={{ color: 'success.main', fontSize: '1.5rem', fontWeight: 600 }}>
              AED {partnerDetails.totalCommissionEarned.toLocaleString()}
            </Typography>
          </Card>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <Card sx={{ p: 2, borderRadius: 2 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, mb: 0.75 }}>
              <Icon sx={{ color: 'warning.main', fontSize: '1.25rem' }}>hourglass_empty</Icon>
              <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.75rem' }}>
                Pending Payment
              </Typography>
            </Box>
            <Typography variant="h5" sx={{ color: 'warning.main', fontSize: '1.5rem', fontWeight: 600 }}>
              AED {partnerDetails.pendingCommission.toLocaleString()}
            </Typography>
          </Card>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <Card sx={{ p: 2, borderRadius: 2 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, mb: 0.75 }}>
              <Icon sx={{ color: 'info.main', fontSize: '1.25rem' }}>check_circle</Icon>
              <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.75rem' }}>
                Paid Commission
              </Typography>
            </Box>
            <Typography variant="h5" sx={{ color: 'info.main', fontSize: '1.5rem', fontWeight: 600 }}>
              AED {partnerDetails.paidCommission.toLocaleString()}
            </Typography>
          </Card>
        </Grid>
      </Grid>

      {/* Tabs for detailed information */}
      <Card sx={{ mb: 2 }}>
        <Tabs
          value={currentTab}
          onChange={handleTabChange}
          sx={{
            '& .MuiTab-root': {
              textTransform: 'none',
              fontSize: '0.875rem',
              fontWeight: 500,
              minHeight: 48
            }
          }}
        >
          <Tab label="Referred Customers" />
          <Tab label="Channel Partner Users" />
          <Tab label="Payment History" />
          <Tab label="Commission Breakdown" />
        </Tabs>
      </Card>

      {/* Tab Content */}
      {currentTab === 0 && (
        <Card sx={{ p: 3 }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
            <Typography variant="h6" sx={{ fontSize: '1.125rem', fontWeight: 600 }}>
              Referred Customers
            </Typography>
            <WDButton
              variant="gradient"
              color="success"
              startIcon={<Icon sx={{ fontSize: '18px !important' }}>link</Icon>}
              onClick={handleLinkCustomer}
              size="small"
              sx={{
                py: 0.75,
                px: 2,
                fontSize: '0.875rem',
                textTransform: 'none',
                fontWeight: 500
              }}
            >
              Link Customer
            </WDButton>
          </Box>
          {referredCustomers.length === 0 ? (
            <Alert severity="info" icon={<Icon>info</Icon>}>
              No customers referred yet. Use "Link Customer" to add existing customers to this channel partner.
            </Alert>
          ) : (
            <TableContainer component={Paper} variant="outlined">
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell><strong>Customer Name</strong></TableCell>
                    <TableCell><strong>Join Date</strong></TableCell>
                    <TableCell><strong>Total Revenue</strong></TableCell>
                    <TableCell><strong>Commission Earned</strong></TableCell>
                    <TableCell><strong>Active Tickets</strong></TableCell>
                    <TableCell><strong>Status</strong></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {referredCustomers.map((customer) => (
                    <TableRow key={customer.id}>
                      <TableCell>{customer.name}</TableCell>
                      <TableCell>{moment(customer.joinDate).format('MMM DD, YYYY')}</TableCell>
                      <TableCell>AED {customer.totalRevenue.toLocaleString()}</TableCell>
                      <TableCell sx={{ color: 'success.main', fontWeight: 'bold' }}>
                        AED {customer.commissionEarned.toLocaleString()}
                      </TableCell>
                      <TableCell>{customer.activeTickets}</TableCell>
                      <TableCell>
                        <Chip
                          label={customer.status}
                          size="small"
                          color={customer.status === 'Active' ? 'success' : 'default'}
                        />
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </Card>
      )}

      {currentTab === 1 && (
        <Card sx={{ p: 3 }}>
          <ChannelPartnerUsers partnerId={partnerId} />
        </Card>
      )}

      {currentTab === 2 && (
        <Card sx={{ p: 3 }}>
          <Typography variant="h6" sx={{ mb: 2 }}>
            Payment History
          </Typography>
          <TableContainer component={Paper} variant="outlined">
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell><strong>Date</strong></TableCell>
                  <TableCell><strong>Period</strong></TableCell>
                  <TableCell><strong>Amount</strong></TableCell>
                  <TableCell><strong>Payment Method</strong></TableCell>
                  <TableCell><strong>Reference</strong></TableCell>
                  <TableCell><strong>Status</strong></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {DUMMY_PAYMENT_HISTORY.map((payment) => (
                  <TableRow key={payment.id}>
                    <TableCell>{moment(payment.date).format('MMM DD, YYYY')}</TableCell>
                    <TableCell>{payment.period}</TableCell>
                    <TableCell sx={{ fontWeight: 'bold' }}>
                      AED {payment.amount.toLocaleString()}
                    </TableCell>
                    <TableCell>{payment.paymentMethod}</TableCell>
                    <TableCell>{payment.referenceNumber}</TableCell>
                    <TableCell>
                      <Chip
                        label={payment.status}
                        size="small"
                        color={payment.status === 'Paid' ? 'success' : 'warning'}
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Card>
      )}

      {currentTab === 3 && (
        <Card sx={{ p: 3 }}>
          <Typography variant="h6" sx={{ mb: 2 }}>
            Commission Breakdown by Service
          </Typography>
          <TableContainer component={Paper} variant="outlined">
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell><strong>Service Name</strong></TableCell>
                  <TableCell><strong>Transactions</strong></TableCell>
                  <TableCell><strong>Total Revenue</strong></TableCell>
                  <TableCell><strong>Commission Earned</strong></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {DUMMY_COMMISSION_BREAKDOWN.map((item, index) => (
                  <TableRow key={index}>
                    <TableCell>{item.serviceName}</TableCell>
                    <TableCell>{item.transactions}</TableCell>
                    <TableCell>AED {item.totalRevenue.toLocaleString()}</TableCell>
                    <TableCell sx={{ color: 'success.main', fontWeight: 'bold' }}>
                      AED {item.commissionEarned.toLocaleString()}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Card>
      )}

      {/* Edit Channel Partner Details Dialog */}
      <Dialog open={editDialogOpen} onClose={() => setEditDialogOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Icon>edit</Icon>
            Edit Channel Partner Details
          </Box>
        </DialogTitle>
        <DialogContent>
          <Box sx={{ pt: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
            <TextField
              label="Organization Name"
              value={editFormData.name}
              onChange={(e) => setEditFormData({ ...editFormData, name: e.target.value })}
              fullWidth
              required
            />
            <TextField
              label="Contact Person"
              value={editFormData.contactPerson}
              onChange={(e) => setEditFormData({ ...editFormData, contactPerson: e.target.value })}
              fullWidth
              required
            />
            <TextField
              label="Email"
              type="email"
              value={editFormData.email}
              onChange={(e) => setEditFormData({ ...editFormData, email: e.target.value })}
              fullWidth
              required
            />
            <TextField
              label="Contact Number"
              value={editFormData.contactNumber}
              onChange={(e) => setEditFormData({ ...editFormData, contactNumber: e.target.value })}
              fullWidth
              placeholder="+971 XX XXX XXXX"
              required
            />
            <TextField
              label="Address"
              value={editFormData.address}
              onChange={(e) => setEditFormData({ ...editFormData, address: e.target.value })}
              fullWidth
              multiline
              rows={3}
              required
            />
            <Alert severity="info" icon={<Icon>info</Icon>}>
              Update the channel partner organization details. These changes will be saved to the system.
            </Alert>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setEditDialogOpen(false)}
            color="inherit"
            disabled={isEditLoading}
          >
            Cancel
          </Button>
          <Button
            onClick={handleSaveEditChanges}
            variant="contained"
            color="primary"
            disabled={isEditLoading || !editFormData.name || !editFormData.email}
          >
            {isEditLoading ? 'Saving...' : 'Save Changes'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Link Existing Customer Dialog */}
      <Dialog open={linkCustomerDialogOpen} onClose={() => setLinkCustomerDialogOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Icon>link</Icon>
            Link Existing Customer
          </Box>
        </DialogTitle>
        <DialogContent>
          <Box sx={{ pt: 2 }}>
            <Grid container spacing={2}>
              {getUnlinkedCustomers().length === 0 ? (
                <Grid item xs={12}>
                  <Alert severity="warning" icon={<Icon>warning</Icon>}>
                    All available customers are already linked to this channel partner.
                  </Alert>
                </Grid>
              ) : (
                <>
                  <Grid item xs={12}>
                    <TextField
                      select
                      label="Select Customer"
                      value={selectedExistingCustomer}
                      onChange={(e) => setSelectedExistingCustomer(e.target.value)}
                      fullWidth
                      required
                      helperText="Select an existing customer to link to this channel partner"
                    >
                      <MenuItem value="" disabled>
                        Choose a customer
                      </MenuItem>
                      {getUnlinkedCustomers().map((customer) => (
                        <MenuItem key={customer.id} value={customer.id}>
                          <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%', alignItems: 'center' }}>
                            <Box>
                              <Typography variant="body2" sx={{ fontWeight: 500 }}>
                                {customer.name}
                              </Typography>
                              <Typography variant="caption" color="text.secondary">
                                {customer.accountNumber}
                              </Typography>
                            </Box>
                            <Chip
                              label={`AED ${customer.totalRevenue.toLocaleString()}`}
                              size="small"
                              color="primary"
                              variant="outlined"
                            />
                          </Box>
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>

                  <Grid item xs={12}>
                    <Alert severity="info" icon={<Icon>info</Icon>}>
                      Linking this customer will assign them to <strong>{partnerDetails.name}</strong>.
                      They will inherit the default commission rate ({partnerDetails.commissionType === 'PERCENTAGE' ? `${partnerDetails.commissionValue}%` : `AED ${partnerDetails.commissionValue}`}) until customized.
                    </Alert>
                  </Grid>
                </>
              )}
            </Grid>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setLinkCustomerDialogOpen(false)} color="inherit">
            Cancel
          </Button>
          <Button
            onClick={handleSaveLinkedCustomer}
            variant="contained"
            color="primary"
            disabled={!selectedExistingCustomer}
          >
            Link Customer
          </Button>
        </DialogActions>
      </Dialog>
    </WDBox>
  );
};

export default ChannelPartnerDetail;
